import { Container, Grid, Box } from '@mui/material';
import React from 'react';
import OurTeamScss from './OurTeam.module.scss';
import { TeamData } from '../../Data/teamMember.js';


function OurTeam() {
    return (
        <section id={OurTeamScss.OurTeam}>
            <Container maxLength='lg'>
                <Box className={OurTeamScss.OurTeamHead}>
                    <span>Our team</span>
                    <p>Our employees</p>
                </Box>
                <Grid container className={OurTeamScss.OurTeamBody}>
                    {
                        TeamData.map(member =>
                            <Grid item lg={3} md={4} sm={6} xs={12} sx={{ px: "1rem" }} key={member.id}>
                                <Box className={OurTeamScss.OurTeamBodyItem}>
                                    <Box className={OurTeamScss.OurTeamBodyItemImg}>
                                        <img src={member.img} alt='Team member'></img>
                                    </Box>
                                    <p>{member.name}</p>
                                    <span>{member.work}</span>
                                </Box>
                            </Grid>

                        )
                    }

                </Grid>
            </Container>
        </section>
    )
}

export default OurTeam;